// API client for the customer self-service portal (/api/portal/*).
// Mirrors the auth-header + config.apiBaseUrl conventions used by the other
// service modules. All calls are scoped to the caller's own customer proxy team.
import config from '../config';
import authService from './authService';

const base = `${config.apiBaseUrl}/api/portal`;

async function request(path, options = {}) {
  const res = await fetch(`${base}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...authService.getAuthHeaders(),
      ...(options.headers || {})
    }
  });
  let body = null;
  try {
    body = await res.json();
  } catch (e) {
    body = null;
  }
  if (!res.ok || (body && body.success === false)) {
    throw new Error((body && body.error) || `Request failed (HTTP ${res.status})`);
  }
  return body;
}

const customerPortalService = {
  // Products the vendor has enabled for self-service for this customer team.
  async getProducts(teamId) {
    const body = await request(`/products?teamId=${encodeURIComponent(teamId)}`);
    return body.products || [];
  },

  // The customer's own API keys.
  async getKeys(teamId) {
    const body = await request(`/keys?teamId=${encodeURIComponent(teamId)}`);
    return body.keys || [];
  },

  // Self-issue a key for an entitled product (plan resolved server-side).
  async createKey(teamId, productId, nickname) {
    const body = await request('/keys', {
      method: 'POST',
      body: JSON.stringify({ teamId, productId, nickname: nickname || undefined })
    });
    return body.apiKey;
  },

  async updateKey(keyId, updates) {
    return request(`/keys/${encodeURIComponent(keyId)}`, {
      method: 'PATCH',
      body: JSON.stringify(updates)
    });
  },

  async deleteKey(keyId) {
    return request(`/keys/${encodeURIComponent(keyId)}`, { method: 'DELETE' });
  }
};

export default customerPortalService;
